/**
 * privacyConstants.js
 * Dati del Titolare del Trattamento per i riferimenti GDPR nella dashboard.
 * Fonte: Informativa Privacy ANUTEL ETS (art. 13 Reg. UE 2016/679)
 * Aggiornato: 2026-06-29
 */

export const PRIVACY = {
  titolare: 'ANUTEL ETS',
  gdprRef: 'Reg. UE 2016/679',
  emailPrivacy: 'privacy@anutel.it',
  emailDpo: 'dpo@anutel.it',
  urlInformativa: 'https://www.anutel.it/utente/associazione/articolo/95798',
  urlCookie: 'https://www.anutel.it/utente/associazione/articolo/19161',
  urlGarante: 'https://www.garanteprivacy.it',
  urlInformativaConvegni: 'https://www.anutel.it/utente/informativa-formazione',
  urlInformativaAccount:  'https://www.anutel.it/utente/informativa-account',
};

